import React from 'react';
export interface IGenerateLettersOptions {
    upperCase?: boolean,
    includeNumbers?: boolean
}

export default function useRandom () {
    const generateLetters = React.useCallback((length: number, options?: IGenerateLettersOptions) => {
        var result           = [];
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + (options?.upperCase !== true ? 'abcdefghijklmnopqrstuvwxyz' : '') + (options?.includeNumbers !== false ? '0123456789' : '');
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
        }
       
        return result.join('');
    }, []);

    const generateToken = React.useCallback(() => {
        return new Date().toString();
    }, [])

    return React.useMemo(() => ({
        generateLetters, generateToken
    }), [generateLetters, generateToken]);
}